module.exports = __webpack_public_path__ + "img/Early Warning.bc39eaa7.png";